module.exports = __webpack_public_path__ + "img/talent.c05d39e2.svg";